import { Button } from "../../../../components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../../../components/ui/dialog";
import { Input } from "../../../../components/ui/input";

/**
 * SkuEditorDialog — Package B buyer↔vendor SKU mapping editor.
 * Companion to VendorSkusPanel.
 * Extracted from SellerDropship.jsx in Phase 3 refactor.
 */
export default function SkuEditorDialog({ skuDraft, setSkuDraft, saveSkuB }) {
  return (
<Dialog open={!!skuDraft} onOpenChange={(v) => !v && setSkuDraft(null)}>
  <DialogContent className="sm:max-w-[440px]" data-testid="sku-dialog">
    <DialogHeader>
      <DialogTitle>{skuDraft?.id ? "Edit mapping" : "New vendor-SKU mapping"}</DialogTitle>
    </DialogHeader>
    {skuDraft && (
      <div className="space-y-3 text-[12.5px]">
        <div>
          <label className="text-[10.5px] mono uppercase tracking-[0.16em] text-foreground/55 block mb-1">Buyer SKU (external)</label>
          <Input value={skuDraft.buyer_sku || ""} onChange={e => setSkuDraft({ ...skuDraft, buyer_sku: e.target.value })}
            data-testid="sku-buyer" className="h-10 mono"/>
        </div>
        <div>
          <label className="text-[10.5px] mono uppercase tracking-[0.16em] text-foreground/55 block mb-1">Vendor SKU (yours)</label>
          <Input value={skuDraft.vendor_sku || ""} onChange={e => setSkuDraft({ ...skuDraft, vendor_sku: e.target.value })}
            data-testid="sku-vendor" className="h-10 mono"/>
        </div>
        <div>
          <label className="text-[10.5px] mono uppercase tracking-[0.16em] text-foreground/55 block mb-1">Product name (optional)</label>
          <Input value={skuDraft.product_name || ""} onChange={e => setSkuDraft({ ...skuDraft, product_name: e.target.value })}
            data-testid="sku-product" className="h-10"/>
        </div>
        <Button onClick={saveSkuB}
          data-testid="sku-save"
          className="w-full h-10 rounded-full bg-foreground text-background hover:bg-foreground/90">
          Save mapping
        </Button>
      </div>
    )}
  </DialogContent>
</Dialog>
  );
}
